module.exports = __webpack_public_path__ + "img/title.0c87a93a.png";